import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import PageTitle from "../../Components/PageTitle";
import MessFacilityBanner from "../../assets/MessFacility.png";

const MessFacility = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Mess Facility - Shree Mangalam School"
        description="Experience nutritious, hygienic, and student-friendly meals at Shree Mangalam School's mess facility. We ensure a healthy diet to support academic excellence."
        url="/mess-facility"
        keywords="mess facility, school meals, student food service, hygienic food, Shree Manglam mess, RIMC coaching nutrition"
      />

      <Header image={MessFacilityBanner} alt={"Mess Facility Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Mess Facility – Healthy Food, Happy Students
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we believe that nutritious
          food is essential for a student’s overall growth and performance. Our
          mess facility is designed to offer fresh, hygienic, and wholesome
          meals every day to students residing in our hostel. Special attention
          is given to maintaining cleanliness, balanced diets, and taste to
          ensure that children enjoy their meals and stay energetic throughout
          their academic and extracurricular activities.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          The mess acts not just as a place to eat, but as a space where
          students learn the importance of healthy living, discipline, and
          respect for food.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Nutritious and Balanced Meals:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We serve well-planned meals that include a balanced mix of
          carbohydrates, proteins, vitamins, and minerals — promoting both
          physical and mental development.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Hygiene and Cleanliness:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our kitchen and dining areas are maintained with the highest hygiene
          standards, with regular sanitization and clean cooking practices.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Fresh and Seasonal Ingredients:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Meals are prepared using fresh, locally-sourced, and seasonal
          vegetables and ingredients to ensure maximum nutrition and taste.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Pure Vegetarian Menu:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We provide pure vegetarian meals, keeping in mind the traditional
          dietary preferences of most families and students.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Safe Drinking Water:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Filtered and purified drinking water is available at all times to
          ensure the health and safety of all students.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Personalized Care:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We monitor students’ eating habits and ensure that every child
          receives adequate nutrition; special dietary needs are also addressed
          whenever necessary.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Homely Environment:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Meals are served in a friendly, organized setting, encouraging good
          eating habits, table manners, and community bonding.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Special Menus on Festivals:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          During festivals and celebrations, we offer special menus so that
          students feel the joy of home even while being away from it.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, our mess facility reflects
          our commitment to the holistic well-being of every student — because
          healthy children build a healthy future.
        </Typography>
      </Container>
      <Footer />
    </>
  );
};

export default MessFacility;
